<template>
  <div :class="['footer-wrapper', className]">
    <div class="frame-41">
      <div class="frame-42">
        <img
          class="logo-off"
          alt="Logo off"
          src="https://c.animaapp.com/nNxA75tB/img/logo-off-1-1.svg"
        />
        <p class="text-wrapper-24">
          Florisuite est la plateforme tout-en-un conçue pour les fleuristes,
          offrant des outils puissants pour une gestion optimisée.
        </p>
      </div>
      <div class="frame-43">
        <div class="frame-44">
          <div class="text-wrapper-25">Produit</div>
          <div class="frame-45">
            <RouterLink class="text-wrapper-26 footer-link" to="/fonctionnalites">
              Fonctionnalités
            </RouterLink>
            <RouterLink class="text-wrapper-27 footer-link" to="/tarifs">
              Tarifs
            </RouterLink>
            <RouterLink class="text-wrapper-27 footer-link" to="/inscription">
              Démo
            </RouterLink>
            <RouterLink class="text-wrapper-27 footer-link" to="/inscription">
              Voir la démo…
            </RouterLink>
          </div>
        </div>
        <div class="frame-44">
          <div class="text-wrapper-25">Entreprise</div>
          <div class="frame-46">
            <div class="text-wrapper-26">À propos</div>
            <div class="text-wrapper-27">Carrières</div>
            <div class="text-wrapper-27">Blog</div>
          </div>
        </div>
        <div class="frame-44">
          <div class="text-wrapper-25">Support</div>
          <div class="frame-47">
            <RouterLink class="text-wrapper-26 footer-link" to="/tarifs#faq">
              FAQ
            </RouterLink>
            <RouterLink class="text-wrapper-27 footer-link" to="/contact">
              Aide et contact
            </RouterLink>
          </div>
        </div>
        <div class="frame-44">
          <div class="text-wrapper-25">Suivez-nous</div>
          <div class="frame-48">
            <a
              class="button-3"
              href="https://www.facebook.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <div class="text">{{ "" }}</div>
              <img
                class="img-3"
                alt="Facebook"
                src="https://c.animaapp.com/nNxA75tB/img/facebook-1.svg"
              />
            </a>
            <a
              class="button-3"
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <div class="text">{{ "" }}</div>
              <img
                class="img-3"
                alt="Instagram"
                src="https://c.animaapp.com/nNxA75tB/img/instagram-1.svg"
              />
            </a>
            <a
              class="button-4"
              href="https://www.linkedin.com/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <div class="linked-in">
                <img
                  class="group"
                  alt="Group"
                  src="https://c.animaapp.com/nNxA75tB/img/group-1@2x.png"
                />
                <div class="text-wrapper-28">link</div>
              </div>
              <div class="text-2">{{ "" }}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-5">
      <img
        class="line"
        alt="Line"
        src="https://c.animaapp.com/nNxA75tB/img/line-1.svg"
      />
      <p class="text-wrapper-29">
        © 2025 Florisuite. Tous droits réservés.
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RouterLink } from "vue-router";

export default defineComponent({
  name: "FooterWrapper",
  components: {
    RouterLink,
  },
  props: {
    className: {
      type: String,
      default: "",
    },
  },
});
</script>

<style>
.footer-wrapper {
  align-items: center;
  background-color: #f1faea;
  border: 0px none;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 25px;
  justify-content: center;
  padding: 35px 30px;
  position: relative;
  width: 100%;
  max-width: 100%;
}

.footer-wrapper .frame-41 {
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 31px 30px;
  justify-content: space-between;
  max-width: 1500px;
  position: relative;
  width: 100%;
}

.footer-wrapper .frame-42 {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-grow: 1;
  gap: 10px;
  max-width: 350px;
  min-width: 0;
  position: relative;
  width: min(100%, 350px);
}

.footer-wrapper .logo-off {
  aspect-ratio: 4.35;
  height: 58px;
  position: relative;
  width: 250px;
}

.footer-wrapper .text-wrapper-24 {
  align-self: stretch;
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 22px;
  position: relative;
}

.footer-wrapper .frame-43 {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-grow: 1;
  flex-wrap: wrap;
  gap: 40px 32px;
  justify-content: space-between;
  max-width: 750px;
  min-width: 0;
  position: relative;
  width: 100%;
}

.footer-wrapper .frame-44 {
  align-items: flex-start;
  display: flex;
  flex: 1 1 140px;
  flex-direction: column;
  gap: 13px;
  min-width: 0;
  position: relative;
}

.footer-wrapper .text-wrapper-25 {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;
  margin-top: -1.00px;
  position: relative;
}

.footer-wrapper .frame-45 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  position: relative;
  width: 100%;
}

.footer-wrapper .text-wrapper-26 {
  align-self: stretch;
  color: #5f5f5f;
  display: block;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: -1.00px;
  min-width: 0;
  overflow-wrap: anywhere;
  position: relative;
  white-space: normal;
  word-break: break-word;
}

.footer-wrapper .text-wrapper-27 {
  align-self: stretch;
  color: #5f5f5f;
  display: block;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  min-width: 0;
  overflow-wrap: anywhere;
  position: relative;
  white-space: normal;
  word-break: break-word;
}

.footer-wrapper .footer-link {
  cursor: pointer;
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
  text-decoration: none;
  white-space: normal;
  word-break: break-word;
}

.footer-wrapper .footer-link:hover {
  color: #1a1a1a;
  text-decoration: underline;
}

.footer-wrapper .footer-link:focus-visible {
  outline: 2px solid rgba(26, 26, 26, 0.35);
  outline-offset: 2px;
  border-radius: 4px;
}

.footer-wrapper .frame-46 {
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  position: relative;
  width: 100%;
}

.footer-wrapper .frame-47 {
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  position: relative;
  width: 100%;
}

.footer-wrapper .frame-48 {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  justify-content: flex-start;
  position: relative;
  width: 100%;
}

.footer-wrapper .button-3 {
  all: unset;
  border: 0px none;
  border-radius: 6px;
  box-sizing: border-box;
  height: 40px;
  overflow: hidden;
  position: relative;
  width: 40px;
}

.footer-wrapper .text {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  left: calc(50.00% + 10px);
  letter-spacing: 0;
  line-height: 22px;
  position: absolute;
  text-align: center;
  top: calc(50.00% - 11px);
  white-space: nowrap;
}

.footer-wrapper .img-3 {
  height: 20px;
  left: calc(50.00% - 10px);
  position: absolute;
  top: calc(50.00% - 10px);
  width: 20px;
}

.footer-wrapper .button-4 {
  align-items: center;
  border: 0px none;
  border-radius: 6px;
  display: inline-flex;
  flex: 0 0 auto;
  overflow: hidden;
  padding: 9px 10px;
  position: relative;
}

.footer-wrapper .linked-in {
  height: 20px;
  overflow: hidden;
  position: relative;
  width: 20px;
}

.footer-wrapper .group {
  height: 17px;
  left: 1px;
  position: absolute;
  top: 1px;
  width: 18px;
}

.footer-wrapper .text-wrapper-28 {
  color: transparent;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  height: 110.00%;
  left: -17.50%;
  letter-spacing: 0;
  line-height: 22px;
  position: absolute;
  text-align: center;
  top: -10.00%;
  white-space: nowrap;
  width: 120.00%;
}

.footer-wrapper .text-2 {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 22px;
  margin-right: -1.00px;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: auto;
}

.footer-wrapper .container-5 {
  align-items: center;
  align-self: stretch;
  border: 0px none;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 33px;
  position: relative;
  width: 100%;
}

.footer-wrapper .line {
  height: 1px;
  margin-top: -0.50px;
  object-fit: cover;
  position: relative;
  width: 100%;
  max-width: 1376px;
}

.footer-wrapper .text-wrapper-29 {
  align-self: stretch;
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
  position: relative;
  text-align: center;
}

@media (max-width: 1100px) {
  .footer-wrapper .frame-41 {
    flex-direction: column;
    gap: 28px;
  }

  .footer-wrapper .frame-42 {
    max-width: none;
    width: 100%;
  }

  .footer-wrapper .frame-43 {
    display: grid;
    gap: 24px 16px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-width: none;
  }
}

@media (max-width: 768px) {
  .footer-wrapper {
    padding: 28px 16px;
  }

  .footer-wrapper .frame-41 {
    gap: 24px 16px;
  }

  .footer-wrapper .frame-43 {
    grid-template-columns: 1fr;
  }

  .footer-wrapper .container-5 {
    gap: 20px;
  }
}
</style>
